import { render, staticRenderFns } from "./LandingApp.vue?vue&type=template&id=5f6615eb&scoped=true"
import script from "./LandingApp.vue?vue&type=script&lang=js"
export * from "./LandingApp.vue?vue&type=script&lang=js"
import style0 from "./LandingApp.vue?vue&type=style&index=0&id=5f6615eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6615eb",
  null
  
)

export default component.exports